export default {
  enabledUsers: [],
};
